import styled from 'styled-components';
import { media } from '../../../../../../styles-helper';

const Price = styled.div`
  font-size: 24px;
  text-align: center;
  line-height: 60px;
  display: inline-block;
  width: 100px;
  border-right: 1px solid #d5d5d5;
  
  &::after {
    content: 'Ft';
    vertical-align: baseline;
    font-size: 16px;
  }

  ${media.phone`
    font-size: 20px;
    line-height: 50px;
    width: 84px;

    &::after {
      font-size: 14px;
    }
  `}

`;

const HeaderPrice = Price.extend`
  font-size: 14px;
  font-weight: bold;
  color: #808080;

  &::after {
    content: '';
  }

  ${media.phone`
    font-size: 12px;
  `}
`;

export {
  Price,
  HeaderPrice
};



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/components/PriceDiff/styles.js